import R from "ramda"
import using from "@inventistudio/using-js"

function dotPath(path, obj, value) {
  return using(path)
    .do(R.split("."))
    .do(R.lensPath)
    .doIf(value !== undefined, lens => R.set(lens, value, obj))
    .doIf(value === undefined, lens => R.view(lens, obj))
    .value()
}

export default {
  dotPath,
}



// WEBPACK FOOTER //
// ./src/utils/common.js